import * as tslib_1 from "tslib";
import { AbstractionBase } from "@awayjs/core";
import { DisplayObjectEvent, AxisAlignedBoundingBox, BoundingSphere, BoundsType, NullBounds } from "@awayjs/scene";
/**
 * @class away.partition.EntityNode
 */
var DisplayObjectNode = (function (_super) {
    tslib_1.__extends(DisplayObjectNode, _super);
    function DisplayObjectNode(entity, pool) {
        var _this = _super.call(this, entity, pool) || this;
        _this.numEntities = 0;
        _this.isSceneGraphNode = false;
        _this._boundsDirty = true;
        _this._onInvalidatePartitionBoundsDelegate = function (event) { return _this._onInvalidatePartitionBounds(event); };
        _this._entity = entity;
        _this._entity.addEventListener(DisplayObjectEvent.INVALIDATE_PARTITION_BOUNDS, _this._onInvalidatePartitionBoundsDelegate);
        _this._boundsType = _this._entity.boundsType;
        return _this;
    }
    Object.defineProperty(DisplayObjectNode.prototype, "debugVisible", {
        get: function () {
            return this._entity.debugVisible;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DisplayObjectNode.prototype, "bounds", {
        /**
         * @internal
         */
        get: function () {
            if (this._boundsDirty)
                this._updateBounds();
            return this._bounds;
        },
        enumerable: true,
        configurable: true
    });
    /**
     *
     * @returns {boolean}
     */
    DisplayObjectNode.prototype.isCastingShadow = function () {
        return this._entity.castsShadows;
    };
    /**
     *
     * @returns {boolean}
     */
    DisplayObjectNode.prototype.isMask = function () {
        return this._entity.maskMode;
    };
    DisplayObjectNode.prototype.onClear = function (event) {
        _super.prototype.onClear.call(this, event);
        this._entity.removeEventListener(DisplayObjectEvent.INVALIDATE_PARTITION_BOUNDS, this._onInvalidatePartitionBoundsDelegate);
        this._entity = null;
        if (this._bounds)
            this._bounds.dispose();
        this._bounds = null;
    };
    DisplayObjectNode.prototype.onInvalidate = function (event) {
        _super.prototype.onInvalidate.call(this, event);
        if (this._boundsType != this._entity.boundsType) {
            this._boundsType = this._entity.boundsType;
            this._boundsDirty = true;
        }
    };
    /**
     *
     * @param planes
     * @param numPlanes
     * @returns {boolean}
     */
    DisplayObjectNode.prototype.isInFrustum = function (planes, numPlanes) {
        return true;
    };
    /**
     * @inheritDoc
     */
    DisplayObjectNode.prototype.isIntersectingRay = function (rayPosition, rayDirection) {
        return true;
    };
    /**
     *
     * @returns {boolean}
     */
    DisplayObjectNode.prototype.isRenderable = function () {
        return true;
    };
    DisplayObjectNode.prototype.renderBounds = function (traverser) {
        traverser.applyEntity(this.bounds.boundsPrimitive);
    };
    /**
     * @inheritDoc
     */
    DisplayObjectNode.prototype.acceptTraverser = function (traverser) {
        // do nothing here
    };
    DisplayObjectNode.prototype._onInvalidatePartitionBounds = function (event) {
        // do nothing here
    };
    DisplayObjectNode.prototype._updateBounds = function () {
        if (this._bounds)
            this._bounds.dispose();
        if (this._boundsType == BoundsType.AXIS_ALIGNED_BOX)
            this._bounds = new AxisAlignedBoundingBox(this._entity);
        else if (this._boundsType == BoundsType.SPHERE)
            this._bounds = new BoundingSphere(this._entity);
        else if (this._boundsType == BoundsType.NULL)
            this._bounds = new NullBounds();
        this._boundsDirty = false;
    };
    return DisplayObjectNode;
}(AbstractionBase));
export { DisplayObjectNode };



// WEBPACK FOOTER //
// ../dist/lib/partition/DisplayObjectNode.js